export default {
  nav: {
    overview: "Обзор",
    profile: "Анкета",
    portfolio: "Портфолио",
    awards: "Достижения",
    application: "Заявка в Союз",
    deposits: "Депонирование",
    events: "Мероприятия",
  },
  noProfile: "Профиль писателя ещё не создан.",
  createProfile: "Заполнить анкету",
  membership: "Статус членства",
  status: {
    none: "нет заявки",
    candidate: "кандидат",
    member: "член Союза",
    rejected: "отклонено",
    suspended: "приостановлено",
  },
  fields: {
    lastName: "Фамилия",
    firstName: "Имя",
    patronymic: "Отчество",
    displayName: "ФИО",
    pseudonym: "Псевдоним",
    region: "Регион",
    bio: "Биография",
    workTitle: "Название произведения",
    awardTitle: "Награда",
  },
  portfolioEmpty: "Портфолио пусто.",
  applicationHint: "Подайте заявку на вступление в Союз писателей после заполнения анкеты.",
  noApplication: "Заявка ещё не подана.",
  submitApplication: "Подать заявку",
  applicationStatus: "Статус заявки: {{status}}",
  overview: {
    welcome: "Здравствуйте, {{name}}!",
    welcomeHint: "Анкета писателя, портфолио, достижения и заявка в Союз — в одном месте.",
    anketaHint: "Заполненная анкета нужна для заявки в Союз и карточки в реестре писателей.",
    membershipLabel: "Членство в Союзе",
    cardNo: "Билет № {{no}}",
    joinedYear: "в Союзе с {{year}} года",
    statsTitle: "Сводка",
    worksTitle: "Произведения",
    worksHint: "Произведения в портфолио и статус их проверки Союзом.",
    worksTotal: "Всего",
    worksVerified: "Подтверждено",
    worksPending: "На проверке",
    awardsTitle: "Достижения",
    awardsHint: "Премии, конкурсы и дипломы.",
    awardsTotal: "Всего",
    awardsLatest: "Последнее",
    servicesTitle: "Быстрые действия",
    services: {
      profile: { title: "Анкета", desc: "ФИО, псевдоним, регион и биография." },
      portfolio: { title: "Портфолио", desc: "Добавить произведение на проверку Союзу." },
      application: { title: "Заявка в Союз", desc: "Подать заявку и следить за решением." },
      deposit: { title: "Депонирование", desc: "Сдать экземпляр в национальный фонд." },
    },
    noProfileTitle: "Анкета писателя ещё не заполнена",
    noProfileHint: "Без анкеты нельзя подать заявку в Союз и вести портфолио.",
  },
  profile: {
    subtitle: "Эти данные увидят Союз писателей и, если разрешите, посетители реестра.",
    sections: {
      name: "ФИО и псевдоним",
      about: "О себе",
      visibility: "Публичность",
    },
    isPublic: "Показывать карточку в реестре писателей",
    isPublicHint: "Карточка появится в разделе «Писатели» на сайте.",
    bioHint: "Несколько абзацев о творческом пути.",
  },
  portfolio: {
    subtitle: "Произведения проходят проверку Союзом перед публикацией в реестре.",
    add: "Добавить произведение",
    addTitle: "Новое произведение",
    emptyTitle: "Портфолио пусто",
    emptyHint: "Добавьте первое произведение — Союз проверит его и подтвердит авторство.",
    search: "Найти в каталоге",
    searchPlaceholder: "Название или ISBN",
    searchEmpty: "В каталоге ничего не найдено — заполните поля ниже",
    searchLoading: "Поиск…",
    catalogHint: "После проверки Союзом это произведение будет указано вашим в каталоге.",
    isbn: "ISBN",
    isbnInvalid: "Укажите ISBN из 10 или 13 знаков",
    columns: { title: "Название", status: "Проверка", added: "Добавлено" },
    verification: {
      pending: "на проверке",
      verified: "подтверждено",
      rejected: "отклонено",
    },
  },
  awards: {
    subtitle: "Премии, конкурсы и дипломы попадут в карточку писателя.",
    add: "Добавить достижение",
    addTitle: "Новое достижение",
    year: "Год",
    yearInvalid: "Укажите год четырьмя цифрами",
    emptyTitle: "Достижений пока нет",
    emptyHint: "Добавьте премию или диплом, чтобы они появились в анкете.",
    columns: { title: "Награда", year: "Год", added: "Добавлено" },
  },
  application: {
    subtitle: "Вступление в Союз писателей: от анкеты до решения.",
    steps: {
      profile: "Анкета заполнена",
      submitted: "Заявка подана",
      decision: "Решение Союза",
    },
    submittedAt: "Подана {{date}}",
    decidedAt: "Решение {{date}}",
    note: "Комментарий Союза",
    needProfile: "Сначала заполните анкету писателя.",
  },
}
